import React from "react";

import NewNoteIcon from "@/assets/images/icons2/icon--clipboard.svg?component";

import { BuildingIcon } from "../../../components/Icons/BuildingIcon";
import { CalendarIcon } from "../../../components/Icons/CalendarIcon";
import { DashboardIcon } from "../../../components/Icons/DashboardIcon";
import { HomeIcon } from "../../../components/Icons/HomeIcon";
import { ICON_SIZES, ICON_TYPES } from "../../../constants/icons";
import { LoupeIcon } from "../../../components/Icons/LoupeIcon";
import { MessagesIcon } from "../../../components/Icons/MessagesIcon";
import { ReportIcon } from "../../../components/Icons/ReportIcon";
import { ScreeningIcon } from "../../../components/Icons/ScreeningIcon";
import { SettingsIcon } from "../../../components/Icons/SettingsIcon";
import { ShieldIcon } from "../../../components/Icons/ShieldIcon";
import { UserIcon } from "../../../components/Icons/UserIcon";

const mapLabelToComponent = (label, active) => {
  switch (label) {
    case "Home":
      return (
        <HomeIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Calendar":

    case "Schedule":
      return (
        <CalendarIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Dashboard":
      return (
        <DashboardIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Practices":
      return (
        <BuildingIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Screening":
      return (
        <ScreeningIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Customer Success":

    case "Patients":
      return (
        <UserIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Reports":
      return (
        <ReportIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Eligibility":
      return (
        <ShieldIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Messages":
      return (
        <MessagesIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Settings":
      return (
        <SettingsIcon
          className={`toolbar-icon ${active ? "active" : null}`}
          iconSize={ICON_SIZES.SMALL}
          iconType={active ? ICON_TYPES.FILLED : ICON_TYPES.OUTLINE}
        />
      );

    case "Search":
      return (
        <LoupeIcon
          className="toolbar-icon loupe-icon"
          iconSize={ICON_SIZES.SMALL}
          iconType={ICON_TYPES.OUTLINE}
        />
      );

    case "Co-Sign":
      return <NewNoteIcon />;

    default:
      return null;
  }
};

export default mapLabelToComponent;
